export interface ExternalWarehouseSaturationDTO {
  zone_code: string;
  current_stock: number;
  max_capacity: number;
  available_capacity: number;
  occupancy_percentage: number;
}

export class ExternalWarehouseSaturationListDTO {
  constructor(public data: ExternalWarehouseSaturationDTO[]) {}
}
